// Runtime-validated environment variables for the admin SPA.
// Vite expands import.meta.env.* at build time; we still check for missing values
// at runtime so that a production bundle deployed without env shows a clear page
// (see features/auth/firebase.ts and App.tsx) instead of crashing.

export interface AdminEnv {
  firebase: {
    apiKey: string
    authDomain: string
    projectId: string
    appId: string
  }
  apiBaseUrl: string
}

export interface EnvResult {
  env: AdminEnv | null
  missing: string[]
}

export function readEnv(): EnvResult {
  const raw = {
    VITE_FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY,
    VITE_FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    VITE_FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    VITE_FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID,
    VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  }

  const missing: string[] = []
  for (const [key, value] of Object.entries(raw)) {
    if (!value || typeof value !== 'string') missing.push(key)
  }

  if (missing.length > 0) {
    return { env: null, missing }
  }

  return {
    env: {
      firebase: {
        apiKey: raw.VITE_FIREBASE_API_KEY as string,
        authDomain: raw.VITE_FIREBASE_AUTH_DOMAIN as string,
        projectId: raw.VITE_FIREBASE_PROJECT_ID as string,
        appId: raw.VITE_FIREBASE_APP_ID as string,
      },
      apiBaseUrl: raw.VITE_API_BASE_URL as string,
    },
    missing: [],
  }
}
